import { createBasicSelector } from 'util/redux'
import selectJiraProjectsById from './selectJiraProjectsById'

export default createBasicSelector(
  selectJiraProjectsById,
  (state, { projectId }) => projectId,
  (projects, projectId) => {
    const project = projects[projectId]
    return project && project.key
  }
)
